export default defineNuxtPlugin((nuxtApp) => {
  const previousWarnHandler = nuxtApp.vueApp.config.warnHandler
  const originalWarn = console.warn

  nuxtApp.vueApp.config.warnHandler = (msg, instance, trace) => {
    if (typeof msg === 'string') {
      if (msg.includes('Suspense') || msg.includes('experimental feature')) return
      if (msg.includes('No match found for location with path')) return
    }

    if (previousWarnHandler) {
      previousWarnHandler(msg, instance, trace)
      return
    }

    originalWarn(msg, trace || '')
  }
})
